import {
    SIGNATORY1_FETCH_START,
    SIGNATORY1_FETCH_DONE,
    SIGNATORY1_FETCH_ERROR,
    SIGNATORY1_IMAGES,
    SIGNATORY2_FETCH_START,
    SIGNATORY2_FETCH_DONE,
    SIGNATORY2_FETCH_ERROR,
    SIGNATORY2_IMAGES,
    REPRESENTATIVE1_FETCH_START,
    REPRESENTATIVE1_FETCH_DONE,
    REPRESENTATIVE1_FETCH_ERROR,
    REPRESENTATIVE1_IMAGES,
    REPRESENTATIVE2_FETCH_START,
    REPRESENTATIVE2_FETCH_DONE,
    REPRESENTATIVE2_FETCH_ERROR,
    REPRESENTATIVE2_IMAGES,
    CUSTODIAN1_FETCH_START,
    CUSTODIAN1_FETCH_DONE,
    CUSTODIAN1_FETCH_ERROR,
    CUSTODIAN1_IMAGES,
    CUSTODIAN2_FETCH_START,
    CUSTODIAN2_FETCH_DONE,
    CUSTODIAN2_FETCH_ERROR,
    CUSTODIAN2_IMAGES,
    VERIFIER_FETCH_START,
    VERIFIER_FETCH_DONE,
    VERIFIER_FETCH_ERROR,
    VERIFIER_IMAGES,
    AUTHORIZER_FETCH_START,
    AUTHORIZER_FETCH_DONE,
    AUTHORIZER_FETCH_ERROR,
    AUTHORIZER_IMAGES
} from "../constants/ActionTypes";

import adminAPI from '../util/AdminApi'

export const getSignatoryOneImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: SIGNATORY1_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: SIGNATORY1_FETCH_DONE });
            dispatch({ type: SIGNATORY1_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: SIGNATORY1_FETCH_DONE });
            dispatch({ type: SIGNATORY1_FETCH_ERROR, payload: error.message });
        });
    }
}


export const getSignatoryTwoImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: SIGNATORY2_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: SIGNATORY2_FETCH_DONE });
            dispatch({ type: SIGNATORY2_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: SIGNATORY2_FETCH_DONE });
            dispatch({ type: SIGNATORY2_FETCH_ERROR, payload: error.message });
        });
    }
}

export const getRepresentativeOneImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: REPRESENTATIVE1_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: REPRESENTATIVE1_FETCH_DONE });
            dispatch({ type: REPRESENTATIVE1_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: REPRESENTATIVE1_FETCH_DONE });
            dispatch({ type: REPRESENTATIVE1_FETCH_ERROR, payload: error.message });
        });
    }
}

export const getRepresentativeTwoImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: REPRESENTATIVE2_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: REPRESENTATIVE2_FETCH_DONE });
            dispatch({ type: REPRESENTATIVE2_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: REPRESENTATIVE2_FETCH_DONE });
            dispatch({ type: REPRESENTATIVE2_FETCH_ERROR, payload: error.message });
        });
    }
}


export const getCustodianOneImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: CUSTODIAN1_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: CUSTODIAN1_FETCH_DONE });
            dispatch({ type: CUSTODIAN1_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: CUSTODIAN1_FETCH_DONE });
            dispatch({ type: CUSTODIAN1_FETCH_ERROR, payload: error.message });
        });
    }
}


export const getCustodianTwoImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: CUSTODIAN2_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: CUSTODIAN2_FETCH_DONE });
            dispatch({ type: CUSTODIAN2_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: CUSTODIAN2_FETCH_DONE });
            dispatch({ type: CUSTODIAN2_FETCH_ERROR, payload: error.message });
        });
    }
}

export const getVerifierImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: VERIFIER_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: VERIFIER_FETCH_DONE });
            dispatch({ type: VERIFIER_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: VERIFIER_FETCH_DONE });
            dispatch({ type: VERIFIER_FETCH_ERROR, payload: error.message });
        });
    }
}


export const getAuthorizerImages = (id) => {
    const endPoint = '/userImages/' + id;
    let token = sessionStorage.getItem('token');

    const opts = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    }

    return async (dispatch) => {
        dispatch({ type: AUTHORIZER_FETCH_START });
        await adminAPI.get(endPoint, opts
        ).then(({ data }) => {
            dispatch({ type: AUTHORIZER_FETCH_DONE });
            dispatch({ type: AUTHORIZER_IMAGES, payload: data });
        }).catch((error) => {
            dispatch({ type: AUTHORIZER_FETCH_DONE });
            dispatch({ type: AUTHORIZER_FETCH_ERROR, payload: error.message });
        });
    }
}

